<!--Tender Card Start From Here-->
<!-- <app-trending-section></app-trending-section> -->
<ng-container *ngIf="tenders?.length > 0; else NoRecordFoundTemplate">
  <div class="card-listing-height">
    <ng-container *ngFor="let tender of tenders; let i = index ; trackBy: trackByTenderId">
      <!-- Display the content of the array object here -->

      <div class="card card-3 mb-20">
        <div class="card-body card-body d-flex justify-content-between row">
          <div class="border-0 d-flex flex-column pb-0 col-sm-12 col-12 p-0">
            <a (click)="navigate(tender?.detailsPageLink, 'title'); $event.preventDefault()"
              href="{{baseUrl+ tender?.detailsPageLink}}">
              <h2 class="mb-0">
                {{tender?.authority == null ? tender?.ministry?.name : tender?.authority?.name}} Tender
              </h2>
            </a>
            <div class="d-flex flex-wrap tender-status-badge-section">
              <div class="tender-status-badge d-inline-block me-2" [ngClass]="[true ? 'blue-badge' : 'orange-badge']">
                <span>{{ tender?.procurement }}</span>
              </div>
              <div *ngIf="tender?.categories?.length > 0" class="cursor-pointer tag-tooltip-hover">
                <div class="tender-status-badge blue-badge d-inline-block me-2">
                  <span>{{ tender.categories[0] }}</span>
                  <div *ngIf="tender.categories.length > 1" class=" view-more-blue-text d-inline-block ">
                    <span class="tooltip-trigger">
                      +{{ tender.categories.length - 1 }}
                    </span>
                    <div class="tooltip-content tag-dropdown">
                      <div class="tag-item" *ngFor="let item of tender.categories?.slice(1)">
                        <span>{{ item }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="location d-flex align-items-center">
                <i class="sprite-img-list location-icon"></i>
                <span>{{ tender?.city?.name }},
                  {{ tender?.state?.name }}</span>
              </div>
            </div>
            <p [title]="tender?.workDescription"> <b>Work Description</b> -
              <span [innerHTML]="tender?.workDescription | highlight:searchTerm"></span>
              <span *ngIf="tender?.workDescription?.split(' ').length > 50">...</span>
            </p>
            <p [title]="tender.summary">
              <span [innerHTML]="tender.summary | wordSlice:50 | highlight:searchTerm"></span>
              <span *ngIf="tender.summary.split(' ').length > 50">...</span>
              <span class="text-blue ms-2" style="cursor: pointer;">
                <a (click)="navigate(tender?.detailsPageLink, 'readmore'); $event.preventDefault();"><b>read
                    more</b></a></span>
            </p>
          </div>
          <div class="col-sm-12 p-0">
            <ul class="list-group list-group-horizontal">
              <li class="list-group-item border-0 p-0 d-flex mb-2 flex-column">
                <span class="d-block list-heading">Opening Date</span>
                <span class="d-block list-heading">{{
                  tender?.startDate | date : "dd MMM YYYY"
                  }}</span>
              </li>
              <li class="list-group-item border-0 p-0 d-flex mb-2 flex-column">
                <span class="d-block list-heading">Closing Date</span>
                <span class="d-block list-heading">{{
                  tender?.endDate | date : "dd MMM YYYY"
                  }}</span>
              </li>
              <li class="list-group-item border-0 p-0 d-flex flex-column">
                <span class="d-block list-heading">Tender Amount</span>
                <span class="badge bg-danger p-0 text-start" [ngClass]="{
                                  'text-red': tender?.amount !== null && tender?.amount !== 0
                                }">
                  {{tender?.amount === null || tender?.amount === 0 ? 'Refer Document' :
                  tender?.amount |
                  tenderAmount}}
                </span>
              </li>
            </ul>
          </div>
          <div class="d-flex align-items-end align-items-lg-end justify-content-between  flex-column flex-lg-row p-0">
            <div class="d-flex align-items-center list-footer-mobile">
              <div class="d-none d-lg-block" *ngIf="tender?.documents && tender.documents.length > 0">
                <div *ngIf="isLoggedIn">
                  <a class="btn blue-round-btn me-3 mt-10" (click)="downloadDoc(tender?.documents[0])">
                    <i class="download-icon sprite-img-list me-2"></i>
                    Download
                  </a>
                </div>
                <div class="d-none d-lg-block" *ngIf="!isLoggedIn">
                  <a class="btn blue-round-btn me-3 mt-10" (click)="openModalWithComponent('download')">
                    <i class="download-icon sprite-img-list me-2"></i>
                    Download
                  </a>
                </div>
              </div>

              <div class="d-flex  justify-content-between align-items-end list-footer-section-mobile">
                <div class="sharing-section align-self-end">
                  <div class="sharing-option">
                    <span>Share this Tender</span>
                    <ul class="list-inline">
                      <li class="list-inline-item">
                        <a class="cursor ps-0"
                          (click)="shareTenderDetails('mailto:?subject='+tender?.summary+'&body='+baseUrl + tender?.detailsPageLink, 'Email')">
                          <i class="sprite-img-list red-mail mail-icon"></i>
                        </a>
                      </li>
                      <li class="list-inline-item">
                        <a class="cursor" (click)="shareTenderDetailsWhatsapp(tender?.detailsPageLink)">
                          <i class="sprite-img-list whatsapp-icon-green whatsapp-icon"></i>
                        </a>
                      </li>
                      <li class="list-inline-item">
                        <a class="clipboard-icon" [ngClass]="{'show': isTooltipActive}"
                          (click)="copyTextToClipboard(tender?.detailsPageLink)"
                          (mouseover)="tooltip = 'Copy to Clipboard'; isTooltipActive = false;">
                          <i class="sprite-img-list link-icon-blue copy-icon"></i>

                          <span class="hovercard">
                            <span class="tooltiptext">{{tooltip}}</span>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="price d-flex align-items-center d-lg-none">
                  <span class="old-price">₹ 299</span>
                  <span class="current-price green-text">Free</span>
                </div>
              </div>
            </div>
            <div class="d-flex d-lg-inline-block align-items-center justify-content-between  tender-mobile-card-footer">
              <div class="price d-none d-lg-block">
                <span class="old-price">₹ 299</span>
                <span class="current-price green-text">Free</span>
              </div>

              <div class="d-flex align-items-center w-100 justify-content-between">

                <div class="d-flex d-lg-none align-items-center"
                  *ngIf="tender?.documents && tender.documents.length > 0">


                  <div class="d-block d-lg-none download-mobile-btn me-2" *ngIf="isLoggedIn">
                    <a class="btn blue-round-btn me-3" (click)="downloadDoc(tender?.documents[0])">
                      <i class="download-icon sprite-img-list me-2"></i>
                      Download
                    </a>
                  </div>

                  <div class="d-block d-lg-none download-mobile-btn me-2" *ngIf="!isLoggedIn">
                    <a class="btn blue-round-btn me-3" (click)="openModalWithComponent('download')">
                      <i class="download-icon sprite-img-list me-2"></i>
                      Download
                    </a>
                  </div>
                </div>
                <div class="view-detail-btn-width  col-6">

                  <a type="button" class="btn btn-danger view-details-btn view-details-btn-width "
                    (click)="navigate(tender?.detailsPageLink, 'viewdetail'); $event.preventDefault()"
                    href="{{baseUrl+ tender?.detailsPageLink}}">
                    <span class="d-flex">
                      View Details <i class="sprite-img-list arrow-right-white"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div *ngIf="tender?.similarTenders?.length > 0" class="similar-section">
          <app-similar-tender class="p-0" [similarTenderData]="tender?.similarTenders"
            [pageType]="'listing'"></app-similar-tender>
        </div>
      </div>

      <!-- Check if the current object is after the second object -->
      <ng-container *ngIf="i > 0">
        <!-- Display the app-credlix-ads-listing-page module only once -->
        <ng-container *ngIf="i === 1">
          <app-credlix-ads-listing-page></app-credlix-ads-listing-page>
          <!-- Set adsDisplayed to true to ensure it appears only once -->
        </ng-container>
      </ng-container>

      <ng-container *ngIf="(tenders?.length > 1 && i === 1) || (tenders?.length === 1 && i === 0)">
        <app-trending-section></app-trending-section>
      </ng-container>

    </ng-container>
  </div>
</ng-container>

<div class="pagination" *ngIf="totalPage > 0">
  <a class="left-pagination-arrow pagination-btn" *ngIf="currentPage > 1"
    [href]="currentPageUrl + '?page=' + (currentPage - 1)" (click)="previousPage(); $event.preventDefault()"
    [class.disabled]="currentPage === 1" rel="prev">
    <i class="sprite-img icon-back"></i><span> Previous </span>
  </a>

  <span class="page-info">Page {{ currentPage }} of {{ totalPage }}</span>

  <a class="right-pagination-arrow pagination-btn" [href]="currentPageUrl + '?page=' + (currentPage + 1)"
    (click)="nextPage(); $event.preventDefault()" [class.disabled]="currentPage === totalPage" rel="next">
    <span> Next </span> <i class="sprite-img icon-next cursor"></i>
  </a>
</div>

<!-- <div class="pagination" *ngIf="totalPage >0">
  <button class="left-pagination-arrow pagination-btn " (click)="previousPage()" [disabled]="currentPage === 1"><i
      class="sprite-img icon-back"></i><span> Previous </span> </button>
  <span class="page-info">Page {{ currentPage }} of {{ totalPage }}</span>
  <button class="right-pagination-arrow pagination-btn" (click)="nextPage()"
    [disabled]="currentPage === totalPage"><span> Next </span> <i class="sprite-img icon-next cursor"></i></button>
</div> -->

<!--No Record Found Template Start From Here-->
<ng-template #NoRecordFoundTemplate>
  <div class="listing-not-found">
    <h4>No Record Found</h4>
    <img src="https://d1tiqtcifmy0l7.cloudfront.net/prod/images/logo/NoProduct.png" alt="No Record Found" />
    <h5>Maybe your search was too specific.</h5>
  </div>
</ng-template>
<!--No Record Found Template End Here-->

<!--Tender Card End Here-->

<div *ngIf="isModalvis">
  <app-signin-with-otp></app-signin-with-otp>
</div>